/* eslint-disable */

import { AddOn } from './AddOn';
//import * as wording from '../../../common/js/wording'
import { AddOnType } from '../FbbEnum';
import * as log from '../../../common/js/appLogger';

/*
Pls submit “Z,1” for equipList plus below values (like Norton):

WiFi路由器	VAS Code	標準月費	Mktg code	收費總額	合約期(月)	合約代號	T&C
Asus RT-AC68U	FBRM1	$40	MVZ08	$960	24	LDJ24M40	N003PB
*/
export class AddOnRentalRouterShort extends AddOn {
	// this mapping id moved to AddOnRentalRouterFree
	static readonly codesInfo = [
		{
			contract: 6,
			avgPrice: 0,
			planCodeAllowed: ['5g_hbb_stu_GRWTH', '5g_hbb_stu_6m'],
			code: 'ADD-ROUTER-6RENT-WPRE',
		},
		{
			contract: 6,
			avgPrice: 0,
			planCodeAllowed: ['5g_hbb_SIA_6m', '5g_hbb_SCHOOL_6m'],
			code: 'ADD-ROUTER-6RENT-NPRE',
		},
		{
			contract: 12,
			avgPrice: 0,
			planCodeAllowed: ['5g_hbb_SCHOOL_12m'],
			code: 'ADD-ROUTER-12RENT',
		},
		{
			contract: 12,
			avgPrice: 0,
			planCodeAllowed: ['5g_hbb_SIA_12m'],
			code: 'ADD-ROUTER-12RENT-WPRE',
		},
	];

	// ADD-ROUTER-24RENT-NPRE-INBASE
	// old code for wetland plan (30-mth contract): "ADD-ROUTER-30RENT-NPRE-WETLAND"

	protected isBasePlanSelected: boolean = false;
	protected baseVasCode: String = 'ADD-ROUTER-%m%RENT-NPRE'; // general for reference

	constructor() {
		super();
		this.key = 'AddOnRentalRouterShort';

		this.boxIconEn = '';
		this.boxIconZh = '';
		this.boxNameEn = 'Router Rental';
		this.boxNameZh = 'Router Rental';
		this.boxAmount = 65; // per month
		this.discountAmount = -1; // 3080
		this.hasRedCounter = false;

		this.type = AddOnType.SINGLE;
	}

	public getAmount(contractMonthStr: string): Number {
		let option = null;
		let contractMonth: Number = parseInt(contractMonthStr || ''); // :Number
		let displayPriceAmount = this.boxAmount;
		for (var i = 0; i < AddOnRentalRouterShort.codesInfo.length; i++) {
			if (AddOnRentalRouterShort.codesInfo[i].contract == contractMonth) {
				option = AddOnRentalRouterShort.codesInfo[i];
				break;
			}
		}

		if (option && option.hasOwnProperty('avgPrice') && option['avgPrice'] != displayPriceAmount) {
			displayPriceAmount = option.avgPrice;
		}

		return displayPriceAmount;
	}

	public getAmountByPlanCode(contractMonthStr: string, planCode: string): Number {
		let option = null;
		let contractMonth: Number = parseInt(contractMonthStr || ''); // :Number
		let displayPriceAmount = this.boxAmount;
		for (var i = 0; i < AddOnRentalRouterShort.codesInfo.length; i++) {
			if (
				AddOnRentalRouterShort.codesInfo[i].contract == contractMonth &&
				AddOnRentalRouterShort.codesInfo[i].planCodeAllowed.indexOf(planCode) > -1
			) {
				option = AddOnRentalRouterShort.codesInfo[i];
				break;
			}
		}
		//console.log('filtered option in card =', option)
		if (option && option.hasOwnProperty('avgPrice') && option['avgPrice'] != displayPriceAmount) {
			displayPriceAmount = option['avgPrice'];
		}
		//console.log('filtered  displayPriceAmount=', displayPriceAmount)
		return displayPriceAmount;
	}

	public getBaseVasCode(): String {
		return this.baseVasCode || '';
	}

	public isAddOnSelected(): boolean {
		return this.boxCount > 0;
	}

	//=================================================================================
	/** no overwrite AddOn one 
    public getData() : any {
        //var data = super.getData()
        return data
    }
    public parse(data: any) {
        //super.parse(data)
    }
    */
	//=================================================================================

	public getPlanVasCode2(contractMonth: Number, planCode: string): string {
		let vasCode;
		if (this.isAddOnSelected()) {
			let option = null;
			for (var i = 0; i < AddOnRentalRouterShort.codesInfo.length; i++) {
				if (
					AddOnRentalRouterShort.codesInfo[i].contract == contractMonth &&
					AddOnRentalRouterShort.codesInfo[i].planCodeAllowed.indexOf(planCode) > -1
				) {
					option = AddOnRentalRouterShort.codesInfo[i];
					break;
				}
			}

			vasCode = option?.code ?? '';
			vasCode = vasCode.replace('%m%', contractMonth.toString());
			return vasCode;
		} else {
			return '';
		}
	}

	public getPlanVasCode(customerType: String, contractMonth: Number, planCode: string): string {
		let vasCode;
		if (this.isAddOnSelected()) {
			let option = null;
			for (var i = 0; i < AddOnRentalRouterShort.codesInfo.length; i++) {
				if (
					AddOnRentalRouterShort.codesInfo[i].contract == contractMonth &&
					AddOnRentalRouterShort.codesInfo[i].planCodeAllowed.indexOf(planCode) > -1
				) {
					option = AddOnRentalRouterShort.codesInfo[i];
					break;
				}
			}

			vasCode = option?.code ?? '';
			vasCode = vasCode.replace('%m%', contractMonth.toString());
			return vasCode;
		} else {
			return '';
		}
	}

	public getPlanVasCode_old(customerType: String, contractMonth: Number): string {
		let vasCode;
		if (this.isAddOnSelected()) {
			vasCode = this.getBaseVasCode() + '';
			vasCode = vasCode.replace('%m%', contractMonth.toString());
			return vasCode;
		} else {
			return '';
		}
	}
}
